import { render, staticRenderFns } from "./sub-total.vue?vue&type=template&id=3063bd2a&scoped=true&"
import script from "./sub-total.vue?vue&type=script&lang=js&"
export * from "./sub-total.vue?vue&type=script&lang=js&"
import style0 from "./sub-total.vue?vue&type=style&index=0&id=3063bd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063bd2a",
  null
  
)

export default component.exports